import { render, staticRenderFns } from "./AdminUserRole.vue?vue&type=template&id=ed326780&scoped=true&"
import script from "./AdminUserRole.vue?vue&type=script&lang=js&"
export * from "./AdminUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed326780",
  null
  
)

export default component.exports